import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/react-hooks";

import JustifiedGrid from "core/JustifiedGrid";
import ImagePreventRightClick from "core/ImagePreventRightClick";
import LoadingSpinner from "core/LoadingSpinner";
import BrowseAllContentTextLink from "../BrowseAllContentTextLink";
import BrowseAllContentCTA from "../BrowseAllContentCTA";
import Heading from "core/Heading";

import { SubpageContainer, SearchAndLinkContainer } from "../styles";

import { GET_PUBLISHED_PHOTO_DATA } from "./queries";
import { PHOTO_DETAIL, BROWSE_BY_CREATOR_USERNAME } from "data/links";

const CreatorProfilePhotos = ({ username }) => {
    const { data, loading } = useQuery(GET_PUBLISHED_PHOTO_DATA, {
        variables: {
            creator: username,
            limit: 12
        }
    });

    if (loading) return <LoadingSpinner />;

    const photoData = data && data.photos && data.photos.items;
    const photoCount = data && data.photos && data.photos.totalCount;

    if (!photoData || (photoData && !photoData.length))
        return (
            <SubpageContainer data-testid="creator-profile-photos-page">
                <Heading size="lg">This creator does not have photos.</Heading>
            </SubpageContainer>
        );

    const photoRatios = photoData.map(item => item.ratio);
    const gridItems = photoData.map((data, index) => (
        <Link
            key={index}
            to={PHOTO_DETAIL.replace(":photoSlugWithId", data.slugWithId)}
        >
            <ImagePreventRightClick
                imageSrc={data.assets.thumbnailMedium}
                srText={data.title}
            />
        </Link>
    ));

    const browseAllProps = {
        contentCount: photoCount,
        contentType: "photo",
        href: BROWSE_BY_CREATOR_USERNAME.replace(":username", username)
    };

    return (
        <SubpageContainer data-testid="creator-profile-photos-page">
            <SearchAndLinkContainer noSearch>
                <BrowseAllContentTextLink {...browseAllProps} />
            </SearchAndLinkContainer>
            <JustifiedGrid itemRatios={photoRatios} items={gridItems} />
            <BrowseAllContentCTA {...browseAllProps} />
        </SubpageContainer>
    );
};

CreatorProfilePhotos.propTypes = {
    username: PropTypes.string.isRequired
};

export default CreatorProfilePhotos;
